import { Analysis } from './analysis.model';
import { Container } from './container.model';
import { Note } from './note.model';
import { Subject } from './subject.model';
import { Parents } from './parents.model';
import { AccessPermission } from './permission.model';
import { Acquisition } from './acquisition.model';

export interface Session extends Container {
  _id: string
  acquisitions?: Acquisition[]
  age?: number
  analyses?: Analysis[]
  created: string
  group: string
  info_exists: boolean
  info?: {}
  label: string
  notes?: Note[]
  modified: string
  operator?: string
  parents?: Parents
  permissions?: AccessPermission[]
  project: string
  project_has_template: boolean
  public: boolean
  satisfies_template?: boolean
  subject?: Subject
  tags?: string[]
  timestamp?: string
  timezone?: string
  uid?: string
  weight?: number
}

export interface SessionPostPayload extends Pick<Session, 'timestamp' | 'label' | 'project'> {
  subject: {
    code: string
  }
}

export enum SessionBidsErrorType {
  Template = 'template',
  SessionBidsError = 'session_bids_error',
}

export interface SessionBidsError {
  type: SessionBidsErrorType,
  message: string
}
